import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "UQu75k",
    defaultMessage: "Approve this fulfillment",
    description: "dialog header",
  },
  description: {
    id: "EHsnZX",
    defaultMessage: "Are you sure you want to approve this fullfillment?",
    description: "dialog description",
  },
  notifyCustomer: {
    id: "IXswaJ",
    defaultMessage: "Send fulfillment email to customer",
    description: "checkbox label, fulfillment approval",
  },
});
